import { z } from "zod";
import { contactMessageSchema } from "./contact";
import { LIMITS } from "./limits";

/**
 * A message waiting for Orla. The site holds it, she collects it and deletes it; it is
 * never emailed anywhere. Only her publishing token can read one.
 */
export const messageSchema = z.object({
  id: z.string().min(1),
  name: contactMessageSchema.shape.name,
  email: contactMessageSchema.shape.email,
  // The visitor's 4,000 characters plus the server's bounded shop enquiry context.
  body: z
    .string()
    .min(LIMITS.contactMessage.min)
    .max(LIMITS.contactMessage.max + 2_048),
  receivedAt: z.iso.datetime(),
  collectedAt: z.iso.datetime().nullable(),
});

/** What the site knows about her post without reading any of it. */
export const mailboxSummarySchema = z.object({
  waiting: z.number().int().nonnegative(),
  collected: z.number().int().nonnegative(),
  oldestWaitingAt: z.iso.datetime().nullable(),
});

export type Message = z.infer<typeof messageSchema>;
export type MailboxSummary = z.infer<typeof mailboxSummarySchema>;
